/** API route map: URLS.Controller.ClientApprovedWcCode */
export const ClientApprovedWcCode = {
      Name: 'ClientApprovedWcCode/',
      GetWcRates: 'get-all-wcrates',
      Add: 'add',
      Delete: 'delete',
      GetApprovedWcCode: 'get-all',
};
